import { computeFaqClick } from './faq-helper';

let ajaxHtmlReplace = (fieldTargetId, externalElement) => {
  $(document).on("ajax:success", fieldTargetId, function(event) {
    const xhr = event.detail[2];
    $(externalElement).html(xhr.responseText);
  });
};

export let relatedContent = (fieldTargetId, externalElement, target, container) => {
  ajaxHtmlReplace(fieldTargetId, externalElement);
  //setup before functions
  let typingTimer;                //timer identifier
  const doneTypingInterval = 500; //time in ms, 5 second for example
  const $input = $('[data-get-question]');
  const clinicalContent = $('.category-container').data('clinical-content');

  //on keyup, start the countdown
  $input.on('keyup', function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });
  //on keydown, clear the countdown
  $input.on('keydown', function () {
    clearTimeout(typingTimer);
  });
  //user is "finished typing," do something
  function doneTyping () {
    const topic_id = $('#question_topic_id').val()

    $.get(window.QuestionForm.searched_faq_path, {
      match_by: $input[0].value,
      target: target,
      clinical_content: clinicalContent,
      topic_id: topic_id
    }, function(data) {
      $(`${container}`).html(data);
      computeFaqClick();
    });
  }
};
